import React from 'react';
import { ReactComponent as EliHead } from 'assets/svg/Eli_Chatbot.svg';

function AIButton({state, calllHandler, extra, size, label='Ask Eli', ...props}) {

    return (
    <div className='flex items-center cursor-pointer py-2' onClick={calllHandler}>
        <div className="absolute">
            <EliHead 
                style={{ 
                width: 'auto', 
                height: `${
                    size === "small"
                        ? "28px"
                        : size === "large" 
                        ? "58px"
                        : "44px"
                    }`
                }}
            />
        </div>
        
      <div
        type="button"
        className={`aibutton 
          focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] 
          aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive 
            dark:hover:bg-accent/50 dark:bg-white/20 ${extra} 
            ${ size === "small"
                ? "ml-2 ps-6 pe-2 text-xs border-1"
                : size === "large" 
                ? "ml-6 ps-10 pe-6 py-1 text-md border-4"
                : "ml-4 ps-8 pe-4 py-1 text-sm"
            }
            `}
      >
        {state?.aiLoading ? (
            <>
                <span className="dark:text-slate-300">Loading...</span>
            </>
        ) : state?.aiAsked ? (
            <>
                <span className="dark:text-slate-300">{label} again</span>
            </>
        ) : (
            <>
                <span className="dark:text-slate-300">{label}</span>
            </>
        )}
        </div>
    </div>
    );
}

export default AIButton;
